import { useState, useEffect, useRef } from 'react';
import DocumentPreview from '../../Create-Investment/documentpreview';
import { useDispatch, useSelector } from 'react-redux';
import { useToast } from '../../../Utils/toastContext';
import { useNavigate, useLocation } from 'react-router-dom';
import { clearApplicationTypeShareHolder } from '../../../Redux/store/accountTypeSlice';
import MindmapTree from '../../../Components/onboarding/onboarding-tree';
import FilePreview from '../../../Components/onboarding/file-preview';
import {
  setStepStatus,
  setRejectedFields,
} from '../../../Redux/store/onboardingFormSlice';
import AgreementCard from '../../../Components/onboarding/agreement-card';
import UserQuestionnaire from '../../../Pages/Risk-Assessment/user-questionnarie';
import {
  CreditCard,
  ShieldCheck,
  User,
  Calendar,
  Lock,
  Eye,
  EyeOff,
  Loader2,
  CheckCircle2,
  ChevronLeft,
  ChevronRight,
  ChevronDown,
  Info,
  LockKeyhole,
  CheckCircle,
} from 'lucide-react';

const ReviewSubmitBusiness = ({ setCurrentStep }) => {
  const dispatch = useDispatch();
  const { showToast } = useToast();
  const roleName = useSelector((state) => state.user.roleName);
  const stepStatus = useSelector((state) => state.form.stepStatus);
  const [showVisualLink, setShowVisualLink] = useState(false);
  const [showCardModal, setShowCardModal] = useState(false);
  const [savingCard, setSavingCard] = useState(false);
  const [isDefaultCard, setIsDefaultCard] = useState(false);
  const [billingErrors, setBillingErrors] = useState({});
  const [defaultCardError, setDefaultCardError] = useState('');
  const BASE_URL = process.env.REACT_APP_BASE_URL;
  const [selectedOptions, setSelectedOptions] = useState([]);
  const [preselectedSignatory, setPreselectedSignatory] = useState({});
  const navigate = useNavigate();
  const [cardSuccess, setCardSuccess] = useState(false);
  const [cvvSuccess, setCvvSuccess] = useState(false);
  const [loading, setLoading] = useState(false);
  const [isCardExist, setIsCardExist] = useState(false);
  const [isAllCompleted, setIsAllCompleted] = useState(false);
  const [selectedCard, setSelectedCard] = useState(null);
  const [cards, setCards] = useState([]);
  const [paymentExpanded, setPaymentExpanded] = useState(false);
  const [firstName, setFirstName] = useState('John');
  const [lastName, setLastName] = useState('Mayer');
  const [email, setEmail] = useState('mayer@gmail.com');
  const [emailContact, setEmailContact] = useState('mayer@gmail.com');

  const [isBillingDifferent, setIsBillingDifferent] = useState(false);
  const [showCvv, setShowCvv] = useState(false);
  const [cardError, setCardError] = useState('');
  const [cvvError, setCvvError] = useState('');
  const [cardFocused, setCardFocused] = useState(false);
  const [cvvFocused, setCvvFocused] = useState(false);
  const microformRef = useRef(null);
  const [microformData, setMicroformData] = useState(null);
  const [microformReady, setMicroformReady] = useState(false);
  const userId = useSelector((state) => state.user.userId);

  const getCardsPerPage = () => {
    if (window.innerWidth < 640) return 1;
    if (window.innerWidth < 1024) return 2;
    return 3;
  };

  const [cardsPerPage, setCardsPerPage] = useState(getCardsPerPage());

  const [billingAddress, setBillingAddress] = useState({
    address: '',
    city: '',
    state: '',
    zip: '',
    country: '',
  });
  // Payment fields
  const [cardName, setCardName] = useState('');
  const [cardNumber, setCardNumber] = useState('');
  const [cardExpiry, setCardExpiry] = useState('');
  const [cardCvv, setCardCvv] = useState('');
  const [cardErrors, setCardErrors] = useState({});
  const [tradingName, setTradingName] = useState('');
  const [mobileNumber, setMobileNumber] = useState('+61 6 7898 7298');
  const [customerType, setCustomerType] = useState('+61 6 7898 7298');
  const [refNumber, setRefNumber] = useState(new Array(7).fill(''));
  const [fullName, setFullName] = useState('John Mayer');
  const [formerNames, setFormerNames] = useState('John Mayer');
  const [toCurrencyText, setToCurrencyText] = useState('');
  const [source, setSource] = useState('');
  const [industry, setIndustry] = useState('');
  const [options, setOptions] = useState([]);
  const [agentName, setAgentName] = useState('');
  const [agentAddress, setAgentAddress] = useState('');
  const [clientNo, setClientNo] = useState('CM0013189P');
  const [fileAttorney, setFileAttorney] = useState(null);
  const [businessNature, setBusinessNature] = useState(null);
  const [signatories, setSignatories] = useState([]);
  const [abn, setAbn] = useState('');
  const [businessActivity, setBusinessActivity] = useState('smaple text');
  const [fullscreen, setFullscreen] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isConfirmWithdraw, setIsConfirmWithdraw] = useState(false);
  const [isConfirmSubmit, setIsConfirmSubmit] = useState(false);
  const [currentDocument, setcurrentDocument] = useState({});
  const [fileThirdParty, setFileThirdParty] = useState(null);
  const [description, setDescription] = useState('testing 1 2 3');
  const [fileProof, setFileProof] = useState(null);
  const [accountType, setAccountType] = useState(null);
  const [accountTypeLabel, setAccountTypeLabel] = useState('Individual');
  const [preview, setPreview] = useState('/avatar.svg');
  const [stateText, setStateText] = useState('');
  const [transactionLevel, setTransactionLevel] = useState('');
  const [investmentAmount, setInvestmentAmount] = useState(null);
  const [isDataAvailable, setIsDataAvailable] = useState(false);
  const [recommendedBy, setRecommendedBy] = useState('');
  const [DoI, setDoI] = useState('');
  const [foreignRegistered, setForeignRegistered] = useState('');
  const [companyRegistrationNumber, setCompanyRegistrationNumber] =
    useState('');
  const [foreignAddress, setForeignAddress] = useState('');
  const [EIN, setEIN] = useState('');
  const [acn, setAcn] = useState('');
  const [stockRegistered, setStockRegistered] = useState('');
  const [arbn, setArbn] = useState('');
  const [companySecretary, setCompanySecretary] = useState('');
  const [companyTypeText, setCompanyTypeText] = useState('');
  const [countryCodeText, setCountryCodeText] = useState('Australia');
  const [registeredAddress, setRegisteredAddress] = useState('');
  const [principalAddress, setPrincipalAddress] = useState('');
  const [stockExchangeText, setStockExchangeText] = useState('');
  const [companyWebsite, setCompanyWebsite] = useState('');
  const [agentMobileNumber, setAgentMobileNumber] = useState('');
  const [expiryDate, setExpiryDate] = useState('02/12/2026');
  const [expiryError, setExpiryError] = useState('');
  const [saveAttempted, setSaveAttempted] = useState(false);
  const [fileArticle, setFileArticle] = useState(null);
  const [fileCompanyOrganisationalChart, setFileCompanyOrganisationalChart] =
    useState(null);
  const [fileAccountantCertificate, setFileAccountantCertificate] =
    useState(null);
  const [fileIncorporationCertificate, setFileIncorporationCertificate] =
    useState(null);
  const [fileOperatingLicenseDocument, setFileOperatingLicenseDocument] =
    useState(null);
  const [fileCertificateOfIncumbency, setFileCertificateOfIncumbency] =
    useState(null);
  const [fileUboCertificate, setFileUboCertificate] = useState(null);
  const [thpDescription, setThpDescription] = useState('');
  const [ticketLink, setTicketLink] = useState('');
  const [filePublicDocument, setFilePublicDocument] = useState(null);
  const [fileExtractDocument, setFileExtractDocument] = useState(null);
  const [fileDisclosure, setFileDisclosure] = useState(null);
  const [fileShareholderCertificate, setFileShareholderCertificate] =
    useState(null);
  const [fileCompanyRegistration, setFileCompanyRegistration] = useState(null);
  const [fileTicket, setFileTicket] = useState(null);
  const [webLink, setWebLink] = useState('');
  const [accounts, setAccounts] = useState([]);
  const [customDate, setCustomDate] = useState('');
  const [minimumInvestment, setminimumInvestment] = useState(0);
  const [limitDurationLabel, setLimitDurationLabel] = useState('Per Day');
  const [signatoryTypeLabel, setSignatoryTypeLabel] = useState(1);
  const [signatoryType, setSignatoryType] = useState(1);
  const [members, setMembers] = useState([]);
  const [collapsedLayers, setCollapsedLayers] = useState({}); // { layerName: true/false }
  const [layers, setLayers] = useState([]);
  const [fileAdviceStatement, setFileAdviceStatement] = useState(null);
  const [fileActivityEvidence, setFileActivityEvidence] = useState(null);
  const [abnStatus, setAbnStatus] = useState('');
  const [ifApplicable, setIfApplicable] = useState('no');
  const [fileFinancialService, setFileFinancialService] = useState(null);
  const [jurisdiction, setJurisdiction] = useState('');
  const [stockexchangeLocation, setStockexchangeLocation] = useState('');
  const [fileForeignRegistration, setFileForeignRegistration] = useState(null);
  const [fileLicense, setFileLicense] = useState(null);
  const [hasLicense, setHasLicense] = useState('no');
  const [licenseNumber, setLicenseNumber] = useState('');
  const [isConfirmVerify, setIsConfirmVerify] = useState(false);
  const [agreements, setagreements] = useState([]);
  const [agreedMap, setAgreedMap] = useState([]);
  const [lockedAgreements, setLockedAgreements] = useState({});
  const totalPages = Math.ceil(cards.length / cardsPerPage);
  const [page, setPage] = useState(0);

  const next = () => {
    setPage((p) => Math.min(p + 1, totalPages - 1));
  };

  const prev = () => {
    setPage((p) => Math.max(p - 1, 0));
  };
  const formatDate = (dateStr) => {
    if (!dateStr) return '';
    const [year, month, day] = dateStr.split('-');
    return `${day}/${month}/${year}`;
  };

  const handleFileClick = (docData) => {
    setcurrentDocument(docData);
    setIsModalOpen(true);
  };
  const clearCardForm = () => {
    // Clear normal fields
    setCardExpiry('');

    setBillingAddress({
      address: '',
      city: '',
      state: '',
      zip: '',
      country: '',
    });

    // Reset toggles
    setIsDefaultCard(false);
    setIsBillingDifferent(false);

    // Clear errors
    setCardError('');
    setCvvError('');
    setExpiryError('');
    setBillingErrors({});

    // Reset success states
    setCardSuccess(false);
    setCvvSuccess(false);

    // Reset focus states
    setCardFocused(false);
    setCvvFocused(false);

    // Reset save state
    setSaveAttempted(false);

    // Optional if you have loading state
    setSavingCard(false);
  };
  useEffect(() => {
    if (showCardModal) {
      clearCardForm();
    }
  }, [showCardModal]);
  const GetAPIcalls = async (url) => {
    const token = localStorage.getItem('jwtToken');
    const apiUrl = `${BASE_URL}${url}`;
    const headers = {
      'Content-Type': 'application/json',
    };

    if (token) {
      headers.Authorization = `Bearer ${token}`;
    }

    try {
      const response = await fetch(apiUrl, {
        method: 'GET',
        headers,
      });

      if (!response.ok) {
        if (response.status === 401) {
          localStorage.removeItem('jwtToken');
          navigate('/login');
          throw new Error('Session expired. Please log in again.');
        }
        const errorData = await response.json().catch(() => ({
          message: 'An unexpected error occurred',
        }));
        throw new Error(errorData.message || 'Something went wrong');
      }

      return await response.json();
    } catch (error) {
      console.error('API Call Error:', error); // Log full error for debugging
      throw new Error(
        typeof error.message === 'string'
          ? error.message
          : 'Network error, please try again later',
      );
    }
  };
  const getCardBrandUI = (brand) => {
    switch (brand) {
      case 'visa':
        return {
          logo: '/visa.svg',
          gradient: 'from-blue-500 to-indigo-600',
        };
      case 'mastercard':
        return {
          logo: '/mastercard.svg',
          gradient: 'from-red-500 to-orange-500',
        };
      case 'amex':
        return {
          logo: '/amex.svg',
          gradient: 'from-cyan-500 to-cyan-600',
        };
      default:
        return {
          logo: null,
          gradient: 'from-gray-600 to-gray-800',
        };
    }
  };
  const validateCardFields = () => {
    const errors = {};
    // if (!cardName || cardName.trim().length < 2)
    //   errors.cardName = "Enter name on card";
    // const nums = cardNumber.replace(/\s/g, "");
    // if (nums.length < 13 || nums.length > 16)
    //   errors.cardNumber = "Enter a valid card number";
    // if (!/^\d{2}\/\d{2}$/.test(cardExpiry))
    //   errors.cardExpiry = "Use MM/YY format";
    // if (!/^\d{3,4}$/.test(cardCvv)) errors.cardCvv = "Enter 3 or 4 digit CVV";
    if (!cardName || cardName.trim().length < 2)
      errors.cardName = 'Enter name on card';
    const nums = cardNumber.replace(/\s/g, '');
    if (nums.length < 13 || nums.length > 16)
      errors.cardNumber = 'Enter a valid card number';
    setCardErrors(errors);
    return Object.keys(errors).length === 0;
  };

  const formatExpiry = (value) => {
    const digits = value.replace(/\D/g, '').slice(0, 4);
    if (digits.length <= 2) return digits;
    return digits.slice(0, 2) + '/' + digits.slice(2);
  };
  const SuccessTick = () => (
    <div
      className="
    animate-in
    zoom-in
    duration-300
    flex
    items-center
    justify-center
    h-6
    w-6
    rounded-full
    bg-emerald-100
    "
    >
      <CheckCircle2 size={18} className="text-emerald-600" />
    </div>
  );

  const maskedCardNumber = (num) => {
    const digits = num.replace(/\D/g, '');
    if (!digits) return '•••• •••• •••• ••••';
    const padded = digits.padStart(16, '•');
    return padded.replace(/(\d{4})(?=\d)/g, '$1 ');
  };
  const EditApplicationAPI = async (sectionId) => {
    const token = localStorage.getItem('jwtToken');
    const headers = {
      'Content-Type': 'application/json',
    };

    if (token) {
      headers.Authorization = `Bearer ${token}`;
    }
    let apiUrl = `${BASE_URL}/api/v1/onboarding/reopen-section?progress_id=${sectionId}`;
    let bodyData = {};
    try {
      const response = await fetch(apiUrl, {
        method: 'PUT',
        headers: headers,
        body: JSON.stringify(bodyData),
      });

      if (!response.ok) {
        if (response.status === 401) {
          localStorage.removeItem('jwtToken');
          navigate('/login');
          throw new Error('Session expired. Please log in again.');
        }
        const errorData = await response.json().catch(() => ({
          message: 'An unexpected error occurred',
        }));
        throw new Error(errorData.message || 'Something went wrong');
      }

      return await response.json();
    } catch (error) {
      throw new Error(error.message || 'Network error, please try again later');
    }
  };
  const withdrawApplicationAPI = async () => {
    const token = localStorage.getItem('jwtToken');
    const headers = {
      'Content-Type': 'application/json',
    };

    if (token) {
      headers.Authorization = `Bearer ${token}`;
    }
    let apiUrl = `${BASE_URL}/v1/onboarding/withdraw`;
    let bodyData = {};
    try {
      const response = await fetch(apiUrl, {
        method: 'POST',
        headers: headers,
        body: JSON.stringify(bodyData),
      });

      if (!response.ok) {
        if (response.status === 401) {
          localStorage.removeItem('jwtToken');
          navigate('/login');
          throw new Error('Session expired. Please log in again.');
        }
        const errorData = await response.json().catch(() => ({
          message: 'An unexpected error occurred',
        }));
        throw new Error(errorData.message || 'Something went wrong');
      }

      return await response.json();
    } catch (error) {
      throw new Error(error.message || 'Network error, please try again later');
    }
  };
  const saveCardAPI = async (transToken) => {
    const token = localStorage.getItem('jwtToken');
    const headers = {
      'Content-Type': 'application/json',
    };

    if (token) {
      headers.Authorization = `Bearer ${token}`;
    }
    let apiUrl = `${BASE_URL}/api/v1/agency/subscription/cards`;
    const bodyData = {
      transient_token: transToken,
      is_default: isDefaultCard,
      billing_address: isBillingDifferent
        ? {
            line1: billingAddress.address,
            city: billingAddress.city,
            state: billingAddress.state,
            postal_code: billingAddress.zip,
            country: billingAddress.country,
          }
        : {},
    };
    try {
      const response = await fetch(apiUrl, {
        method: 'POST',
        headers: headers,
        body: JSON.stringify(bodyData),
      });

      if (!response.ok) {
        if (response.status === 401) {
          localStorage.removeItem('jwtToken');
          navigate('/login');
          throw new Error('Session expired. Please log in again.');
        }
        const errorData = await response.json().catch(() => ({
          message: 'An unexpected error occurred',
        }));
        throw new Error(errorData.message || 'Something went wrong');
      }

      return await response.json();
    } catch (error) {
      throw new Error(error.message || 'Network error, please try again later');
    }
  };
  const makeDefaultCardAPI = async (cardId) => {
    const token = localStorage.getItem('jwtToken');
    const headers = {
      'Content-Type': 'application/json',
    };

    if (token) {
      headers.Authorization = `Bearer ${token}`;
    }
    let apiUrl = `${BASE_URL}/api/v1/agency/subscription/cards/${cardId}/default`;
    const bodyData = {};
    try {
      const response = await fetch(apiUrl, {
        method: 'PUT',
        headers: headers,
        body: JSON.stringify(bodyData),
      });

      if (!response.ok) {
        if (response.status === 401) {
          localStorage.removeItem('jwtToken');
          navigate('/login');
          throw new Error('Session expired. Please log in again.');
        }
        const errorData = await response.json().catch(() => ({
          message: 'An unexpected error occurred',
        }));
        throw new Error(errorData.message || 'Something went wrong');
      }

      return await response.json();
    } catch (error) {
      throw new Error(error.message || 'Network error, please try again later');
    }
  };
  const deleteCardAPI = async (cardId) => {
    const token = localStorage.getItem('jwtToken');
    const headers = {
      'Content-Type': 'application/json',
    };

    if (token) {
      headers.Authorization = `Bearer ${token}`;
    }
    let apiUrl = `${BASE_URL}/api/v1/agency/subscription/cards/${cardId}`;
    const bodyData = {};
    try {
      const response = await fetch(apiUrl, {
        method: 'DELETE',
        headers: headers,
        body: JSON.stringify(bodyData),
      });

      if (!response.ok) {
        if (response.status === 401) {
          localStorage.removeItem('jwtToken');
          navigate('/login');
          throw new Error('Session expired. Please log in again.');
        }
        const errorData = await response.json().catch(() => ({
          message: 'An unexpected error occurred',
        }));
        throw new Error(errorData.message || 'Something went wrong');
      }

      return await response.json();
    } catch (error) {
      throw new Error(error.message || 'Network error, please try again later');
    }
  };
  const handleSaveCard = () => {
    const microform = microformRef.current?.microform;

    if (!microform) {
      console.error('Microform not initialized');

      showToast('Card form is not ready', 'error');

      return;
    }

    microform.createToken(
      {
        expirationMonth: cardExpiry.substring(0, 2),
        expirationYear: '20' + cardExpiry.substring(3, 5),
      },
      async (err, response) => {
        if (err) {
          console.error('CyberSource Token Error', err);

          return;
        }

        console.log('Transient Token:', response);
        // send this token to backend
        const responseSave = await saveCardAPI(response);
        if (responseSave.status == 201) {
          setShowCardModal(false);
          showToast(responseSave.message, 'success');
          getCreditCard();
          setLoading(false);
        } else {
          showToast(responseSave.message, 'error');
          setLoading(false);
        }
      },
    );
  };
  const postApi = async () => {
    const token = localStorage.getItem('jwtToken');
    const headers = {
      'Content-Type': 'application/json',
    };

    if (token) {
      headers.Authorization = `Bearer ${token}`;
    }
    let apiUrl = `${BASE_URL}/api/v1/agency/subscription/microform-session`;
    let bodyData = {};
    try {
      const response = await fetch(apiUrl, {
        method: 'POST',
        headers: headers,
      });

      if (!response.ok) {
        if (response.status === 401) {
          localStorage.removeItem('jwtToken');
          navigate('/login');
          throw new Error('Session expired. Please log in again.');
        }
        const errorData = await response.json().catch(() => ({
          message: 'An unexpected error occurred',
        }));
        throw new Error(errorData.message || 'Something went wrong');
      }

      return await response.json();
    } catch (error) {
      throw new Error(error.message || 'Network error, please try again later');
    }
  };
  useEffect(() => {
    if (showCardModal && microformData?.jwt && window.Flex) {
      initializeMicroform(microformData.jwt);
    }
  }, [showCardModal, microformData]);
  const validateCardForm = () => {
    let isValid = true;

    // Clear previous errors
    setCardError('');
    setCvvError('');
    setExpiryError('');
    setBillingErrors({});
    setDefaultCardError('');

    // Card Number
    if (!cardSuccess) {
      setCardError('Please enter a valid card number');
      isValid = false;
    }

    // CVV
    if (!cvvSuccess) {
      setCvvError('Please enter a valid CVV');
      isValid = false;
    }

    // Expiry
    if (!cardExpiry || cardExpiry.length !== 5) {
      setExpiryError('Please enter a valid expiry date');
      isValid = false;
    } else {
      const [month, year] = cardExpiry.split('/');

      const currentDate = new Date();
      const currentYear = currentDate.getFullYear() % 100;
      const currentMonth = currentDate.getMonth() + 1;

      if (
        Number(month) < 1 ||
        Number(month) > 12 ||
        Number(year) < currentYear ||
        (Number(year) === currentYear && Number(month) < currentMonth)
      ) {
        setExpiryError('Card expiry date is invalid');
        isValid = false;
      }
    }

    // Billing Address Validation
    if (isBillingDifferent) {
      const errors = {};

      if (!billingAddress.address?.trim()) {
        errors.address = 'Address is required';
      }

      if (!billingAddress.city?.trim()) {
        errors.city = 'City is required';
      }

      if (!billingAddress.state?.trim()) {
        errors.state = 'State is required';
      }

      if (!billingAddress.zip?.trim()) {
        errors.zip = 'ZIP code is required';
      }

      if (!billingAddress.country?.trim()) {
        errors.country = 'Country is required';
      }

      if (Object.keys(errors).length > 0) {
        setBillingErrors(errors);
        isValid = false;
      }
    }

    return isValid;
  };
  const initializeMicroform = (jwt) => {
    try {
      console.log('Initializing Microform');

      const flex = new window.Flex(jwt);

      const microform = flex.microform({
        styles: {
          input: {
            'font-size': '16px',
            'font-family': 'Work Sans, sans-serif',
            'letter-spacing': '0.5px',
          },
          ':focus': {
            color: '#0f172a',
          },
          '::placeholder': {
            color: '#b6c2d1',
            'font-size': '16px',
          },
        },
      });

      const number = microform.createField('number', {
        placeholder: 'Card Number',
      });

      const securityCode = microform.createField('securityCode', {
        placeholder: 'CVV',
      });

      let cardValid = false;
      let cvvValid = false;

      number.on('change', function (data) {
        cardValid = data.valid;

        setCardSuccess(data.valid);

        if (data.empty) {
          setCardError('Card number is required');
        } else if (!data.valid) {
          setCardError('Invalid card number');
        } else {
          setCardError('');
        }
      });

      securityCode.on('change', function (data) {
        cvvValid = data.valid;

        setCvvSuccess(data.valid);

        if (data.empty) {
          setCvvError('CVV is required');
        } else if (!data.valid) {
          setCvvError('Invalid CVV');
        } else {
          setCvvError('');
        }
      });
      number.on('focus', () => {
        setCardFocused(true);
      });

      number.on('blur', () => {
        setCardFocused(false);
      });

      securityCode.on('focus', () => {
        setCvvFocused(true);
      });

      securityCode.on('blur', () => {
        setCvvFocused(false);
      });
      number.load('#card-number-container');

      securityCode.load('#card-cvv-container');

      microformRef.current = {
        microform,
        number,
        securityCode,
      };

      console.log('Microform ready');

      setMicroformReady(true);
    } catch (error) {
      console.error('Microform initialization failed', error);
    }
  };
  const openCardCapture = async () => {
    try {
      setLoading(true);

      const response = await postApi(
        '/api/v1/agency/subscription/microform-session',
      );

      const { jwt, client_library } = response.data;

      // Save JWT
      setMicroformData({
        jwt,
      });

      // Open modal first
      setShowCardModal(true);

      console.log('client library:', client_library);
      console.log('jwt:', jwt);
      // Load NAB/Cybersource library
      if (!window.Flex) {
        const script = document.createElement('script');

        script.src = client_library;
        script.async = true;

        script.onload = () => {
          console.log('Flex loaded');
          initializeMicroform(jwt);
        };

        document.body.appendChild(script);
      } else {
        initializeMicroform(jwt);
      }
    } catch (error) {
      showToast(error.message, 'error');
    } finally {
      setLoading(false);
    }
  };
  const buildPayload = () => {
    return {
      card_name: cardName,
      last4: cardNumber.replace(/\s/g, '').slice(-4),
      is_default: true,
    };
  };

  const editPaymentPI = async () => {
    const token = localStorage.getItem('jwtToken');
    const headers = {
      'Content-Type': 'application/json',
    };

    if (token) {
      headers.Authorization = `Bearer ${token}`;
    }
    let apiUrl = `${BASE_URL}/api/v1/onboarding/agency/credit-cards/${isCardExist}`;
    const bodyData = buildPayload();
    try {
      const response = await fetch(apiUrl, {
        method: 'PUT',
        headers: headers,
        body: JSON.stringify(bodyData),
      });

      if (!response.ok) {
        if (response.status === 401) {
          localStorage.removeItem('jwtToken');
          navigate('/login');
          throw new Error('Session expired. Please log in again.');
        }
        const errorData = await response.json().catch(() => ({
          message: 'An unexpected error occurred',
        }));
        throw new Error(errorData.message || 'Something went wrong');
      }

      return await response.json();
    } catch (error) {
      throw new Error(error.message || 'Network error, please try again later');
    }
  };

  const handleSetDefault = async (cardId) => {
    let toastMessage = null;
    try {
      const response = await makeDefaultCardAPI(cardId);
      if (response.status == 201) {
        toastMessage = { message: response.message, type: 'success' };
      } else {
        toastMessage = { message: response.message, type: 'error' };
      }
    } catch (err) {
      toastMessage = { message: err.message, type: 'error' };
      setIsConfirmSubmit(false);
    } finally {
      setLoading(false); // Ensure `loading` is false first
      // Show toast after loading is false
      if (toastMessage) {
        setTimeout(() => {
          showToast(toastMessage.message, toastMessage.type);
        }, 300); // Small delay if needed
      }
    }
  };
  const handleRemoveCard = async (cardId) => {
    let toastMessage = null;
    try {
      const response = await deleteCardAPI(cardId);
      if (response.status == 200) {
        toastMessage = { message: response.message, type: 'success' };
        getCreditCard();
      } else {
        toastMessage = { message: response.message, type: 'error' };
      }
    } catch (err) {
      toastMessage = { message: err.message, type: 'error' };
      setIsConfirmSubmit(false);
    } finally {
      setLoading(false); // Ensure `loading` is false first
      // Show toast after loading is false
      if (toastMessage) {
        setTimeout(() => {
          showToast(toastMessage.message, toastMessage.type);
        }, 300); // Small delay if needed
      }
    }
  };
  const handleEditPayment = async () => {
    let toastMessage = null;
    try {
      const response = await editPaymentPI();
      if (response.status == 200) {
        toastMessage = { message: response.message, type: 'success' };
      } else {
        toastMessage = { message: response.message, type: 'error' };
      }
    } catch (err) {
      toastMessage = { message: err.message, type: 'error' };
      setIsConfirmSubmit(false);
    } finally {
      setLoading(false); // Ensure `loading` is false first
      // Show toast after loading is false
      if (toastMessage) {
        setTimeout(() => {
          showToast(toastMessage.message, toastMessage.type);
        }, 300); // Small delay if needed
      }
    }
  };
  const isAgreementAccepted = (agreement) => {
    return agreement.status === 'AGREED' || agreedMap[agreement.enum] === true;
  };
  const validateAgreementsBeforeNext = () => {
    const missing = agreements
      .map(mapAgreementUI)
      .filter((a) => a.required)
      .filter((a) => !isAgreementAccepted(a));

    return {
      isValid: missing.length === 0,
      missing,
    };
  };
  const mapAgreementUI = (agreement) => {
    return {
      id: agreement.agreement_type.id,
      enum: agreement.agreement_type.enum,
      name: agreement.agreement_type.name,
      description: agreement.agreement_type.description,
      required: agreement.is_required,
      mode: agreement.mode.enum, // UPLOAD_SIGNED | PREVIEW_TICK
      document: agreement.document,
      preview: agreement.preview_document,
      status: agreement.status.enum,
    };
  };

  const getAgreements = async () => {
    try {
      const response = await GetAPIcalls(`/api/v1/onboarding/agreements`);

      if (response.status == 200) {
        setagreements(response.data.agreements);
        const agreedMapFromApi = {};
        const lockedMapFromApi = {};

        response.data.agreements.forEach((item) => {
          const enumKey = item.agreement_type.enum;
          const isAccepted = item.status?.enum === 'AGREED' || !!item.agreed_at;

          agreedMapFromApi[enumKey] = isAccepted;
          lockedMapFromApi[enumKey] = isAccepted;
        });

        setAgreedMap(agreedMapFromApi);
        setLockedAgreements(lockedMapFromApi);
        setIsAllCompleted(response.data.all_completed);
      } else {
        if (response.status === 401) {
          localStorage.removeItem('jwtToken');
          navigate('/login');
        }
      }
    } catch (err) {
      showToast(err.message, 'error');
      setIsAllCompleted(false);
    }
  };
  const getMaskedCardNumber = (last4) => {
    return `xxxx xxxx xxxx ${last4}`;
  };

  const getCreditCard = async () => {
    try {
      const response = await GetAPIcalls(`/api/v1/agency/subscription/cards`);

      if (response.status == 200) {
        if (response.data) {
          setCards(response.data.cards);
        } else {
          setCards([]);
        }
      } else {
        if (response.status === 401) {
          localStorage.removeItem('jwtToken');
          navigate('/login');
        }
      }
    } catch (err) {
      showToast(err.message, 'error');
    }
  };
  const submitAgreementAPI = async (agreementType) => {
    const token = localStorage.getItem('jwtToken');
    const headers = {
      'Content-Type': 'application/json',
    };

    if (token) {
      headers.Authorization = `Bearer ${token}`;
    }
    let apiUrl = `${BASE_URL}/api/v1/onboarding/agreements/${agreementType}/agree`;
    let bodyData = {
      accepted: true,
    };

    try {
      const response = await fetch(apiUrl, {
        method: 'POST',
        headers: headers,
        body: JSON.stringify(bodyData),
      });

      if (!response.ok) {
        if (response.status === 401) {
          localStorage.removeItem('jwtToken');
          navigate('/login');
          throw new Error('Session expired. Please log in again.');
        }
        const errorData = await response.json().catch(() => ({
          message: 'An unexpected error occurred',
        }));
        throw new Error(errorData.message || 'Something went wrong');
      }

      return await response.json();
    } catch (error) {
      throw new Error(error.message || 'Network error, please try again later');
    }
  };
  const handleAcceptAgreement = async (checked, agreement) => {
    let toastMessage = null;
    const enumKey = agreement.enum;

    if (lockedAgreements[enumKey]) return; // 🚫 already accepted
    try {
      setLoading(true);
      if (checked) {
        const response = await submitAgreementAPI(agreement.id);
        if (response.status == 200) {
          toastMessage = {
            message: response.message,
            type: 'success',
          };
          getAgreements();
        } else {
          toastMessage = { message: response.message, type: 'error' };
        }
      }
    } catch (err) {
      toastMessage = { message: err.message, type: 'error' };
    } finally {
      setLoading(false); // Ensure `loading` is false first
      // Show toast after loading is false
      if (toastMessage) {
        setTimeout(() => {
          showToast(toastMessage.message, toastMessage.type);
        }, 300); // Small delay if needed
      }
    }
  };
  const handleWithdraw = async () => {
    let toastMessage = null;
    try {
      const response = await withdrawApplicationAPI();
      if (response.status == 200) {
        setIsConfirmWithdraw(false);
        navigate('/login');
      } else {
        toastMessage = { message: response.message, type: 'error' };
      }
    } catch (err) {
      toastMessage = { message: err.message, type: 'error' };
      setIsConfirmSubmit(false);
    } finally {
      setLoading(false); // Ensure `loading` is false first
      // Show toast after loading is false
      if (toastMessage) {
        setTimeout(() => {
          showToast(toastMessage.message, toastMessage.type);
        }, 300); // Small delay if needed
      }
    }
  };
  const handleEdit = async (sectionId, stepId) => {
    let toastMessage = null;
    try {
      const response = await EditApplicationAPI(sectionId);
      if (response.status == 200) {
        setCurrentStep(stepId);
        const responseStatus = await GetAPIcalls(`/api/v1/onboarding/status`);
        if (responseStatus.status == 200) {
          if (responseStatus.data.length > 0) {
            dispatch(setStepStatus(responseStatus.data));
          }
        }
        const responseRejected = await GetAPIcalls(
          `/api/v1/onboarding/rejected-fields`,
        );
        if (responseRejected.status == 200) {
          dispatch(setRejectedFields(responseRejected.data)); // <-- Save in Redux
        }
      } else {
        toastMessage = { message: response.message, type: 'error' };
      }
    } catch (err) {
      toastMessage = { message: err.message, type: 'error' };
    } finally {
      setLoading(false); // Ensure `loading` is false first
      // Show toast after loading is false
      if (toastMessage) {
        setTimeout(() => {
          showToast(toastMessage.message, toastMessage.type);
        }, 300); // Small delay if needed
      }
    }
  };

  const getDetails = async () => {
    try {
      const response = await GetAPIcalls(
        `/api/v1/onboarding/${roleName}/review-submit/review`,
      );

      if (response.status == 200) {
        //SignUp details
        setFirstName(response.data.open_account_information.first_name);
        setLastName(response.data.open_account_information.last_name);
        setEmail(response.data.open_account_information.email_address);
        setMobileNumber(
          response.data.open_account_information.country_code +
            response.data.open_account_information.mobile_number,
        );
        // Business information
        if (roleName == 'business') {
          setPreview(
            response.data.business_information?.profile_picture
              ?.presigned_url == ''
              ? '/avatar.svg'
              : response.data.business_information.profile_picture
                  ?.presigned_url,
          );
          setFullName(response.data.business_information.business_name);
          setTradingName(response.data.business_information.trading_name);
          setRegisteredAddress(
            response.data.business_information.address?.google_address,
          );
          setPrincipalAddress(
            response.data.business_information.postal_address?.google_address,
          );
          setAbn(response.data.business_information.abn);
          setAcn(response.data.business_information.acn);
          setCompanyWebsite(response.data.business_information.website);
          setIndustry(response.data.business_information.industry);
          setAgentName(response.data.business_information.contact_person_name);
          setEmailContact(
            response.data.business_information.contact_person_email,
          );
          setAgentMobileNumber(
            response.data.business_information.contact_person_phone,
          );
          //Upload docs
          setFileOperatingLicenseDocument(
            response.data.proof_documents.operating_license,
          );
          setExpiryDate(response.data.proof_documents.license_expiry_date);
          setFileExtractDocument(response.data.proof_documents.asic_extract);
          setFileIncorporationCertificate(
            response.data.proof_documents.certificate_of_incorporation,
          );
          setFileCompanyRegistration(
            response.data.proof_documents.registration_certificate,
          );
        }
        // Agency information
        if (roleName == 'agency') {
          setPreview(
            response.data.agency_information?.profile_picture?.presigned_url ==
              ''
              ? '/avatar.svg'
              : response.data.agency_information.profile_picture?.presigned_url,
          );
          setFullName(response.data.agency_information.business_name);
          setTradingName(response.data.agency_information.trading_name);
          setRegisteredAddress(
            response.data.agency_information.address?.google_address,
          );
          setPrincipalAddress(
            response.data.agency_information.postal_address?.google_address,
          );
          setAbn(response.data.agency_information.abn);
          setAcn(response.data.agency_information.acn);
          setCompanyWebsite(response.data.agency_information.website);
          setIndustry(response.data.agency_information.industry);
          setAgentName(response.data.agency_information.contact_person_name);
          setEmailContact(
            response.data.agency_information.contact_person_email,
          );
          setAgentMobileNumber(
            response.data.agency_information.contact_person_phone,
          );
          //Upload docs
          setFileOperatingLicenseDocument(
            response.data.agency_proof_documents.operating_license,
          );
          setExpiryDate(
            response.data.agency_proof_documents.license_expiry_date,
          );
          setFileExtractDocument(
            response.data.agency_proof_documents.asic_extract,
          );
          setFileIncorporationCertificate(
            response.data.agency_proof_documents.certificate_of_incorporation,
          );
          setFileCompanyRegistration(
            response.data.agency_proof_documents.registration_certificate,
          );
        }

        setIsDataAvailable(true);
      } else {
        if (response.status === 401) {
          localStorage.removeItem('jwtToken');
          navigate('/login');
        }
      }
    } catch (err) {
      showToast(err.message, 'error');
      setIsDataAvailable(false);
    }
  };
  const handleCollapseAll = () => {
    const newState = {};
    layers.forEach((l) => {
      newState[l.id] = true; // collapsed
    });
    setCollapsedLayers(newState);
  };

  const handleExpandAll = () => {
    const newState = {};
    layers.forEach((l) => {
      newState[l.id] = false; // expanded
    });
    setCollapsedLayers(newState);
  };
  const submitApplicationAPI = async () => {
    const token = localStorage.getItem('jwtToken');
    const headers = {
      'Content-Type': 'application/json',
    };

    if (token) {
      headers.Authorization = `Bearer ${token}`;
    }
    let apiUrl = `${BASE_URL}/api/v1/onboarding/${roleName}/review-submit/submit`;
    let bodyData = {};
    try {
      const response = await fetch(apiUrl, {
        method: 'POST',
        headers: headers,
        body: JSON.stringify(bodyData),
      });

      if (!response.ok) {
        if (response.status === 401) {
          localStorage.removeItem('jwtToken');
          navigate('/login');
          throw new Error('Session expired. Please log in again.');
        }
        const errorData = await response.json().catch(() => ({
          message: 'An unexpected error occurred',
        }));
        throw new Error(errorData.message || 'Something went wrong');
      }

      return await response.json();
    } catch (error) {
      throw new Error(error.message || 'Network error, please try again later');
    }
  };
  const handleSubmit = async () => {
    let toastMessage = null;
    try {
      const response = await submitApplicationAPI();
      if (response.status == 200) {
        toastMessage = { message: response.message, type: 'success' };
        setIsConfirmSubmit(false);
        const responseStatus = await GetAPIcalls(`/api/v1/onboarding/status`);
        if (responseStatus.status == 200) {
          if (responseStatus.data.length > 0) {
            dispatch(setStepStatus(responseStatus.data));
          }
        }
        const responseRejected = await GetAPIcalls(
          `/api/v1/onboarding/rejected-fields`,
        );
        if (responseRejected.status == 200) {
          dispatch(setRejectedFields(responseRejected.data)); // <-- Save in Redux
        }
      } else {
        toastMessage = { message: response.message, type: 'error' };
      }
    } catch (err) {
      toastMessage = { message: err.message, type: 'error' };
      setIsConfirmSubmit(false);
    } finally {
      setLoading(false); // Ensure `loading` is false first
      // Show toast after loading is false
      if (toastMessage) {
        setTimeout(() => {
          showToast(toastMessage.message, toastMessage.type);
        }, 300); // Small delay if needed
      }
    }
  };

  useEffect(() => {
    getDetails();
    getAgreements();
    getCreditCard();
  }, []);
  return (
    <div className="flex flex-col min-h-[calc(100vh-100px)] w-full max-w-full min-w-0 overflow-x-hidden">
      <div className="flex-grow overflow-visible">
        {loading && (
          <div className="fixed inset-0 w-full h-full flex justify-center items-center bg-black bg-opacity-50 z-[999] p-4">
            <div className="w-12 h-12 border-4 border-white border-t-transparent rounded-full animate-spin"></div>
          </div>
        )}
        {stepStatus.length > 0 &&
          (stepStatus[2].status == 'IN_REVIEW' ||
            stepStatus[2].status == 'COMPLETED') && (
            <div className="mb-2 bg-yellow-100 border-l-4 border-yellow-500 text-yellow-700 p-3 rounded-md text-sm flex items-center">
              <img
                src="/warning-circle.svg"
                alt="Info"
                className="w-4 h-4 mr-2"
              />
              <span>
                Your application is{' '}
                <strong>in review by our onboarding team</strong>. You will be
                notified once the verification is complete.{' '}
              </span>
            </div>
          )}
        <div className="bg-white shadow-md rounded-md p-4">
          <div className="border-b border-colour-custom pb-2">
            <div className="flex items-center space-x-2 mb-2">
              <img src="/note-2.svg" alt="User Avatar" className="h-6 w-6" />
              <h1 className="text-xl font-medium">
                Review And submit your information
              </h1>
            </div>
          </div>
          {isDataAvailable && (
            <>
              <div className="bg-white border rounded-md p-4 mt-2">
                <div className="flex flex-wrap items-center border-colour-custom gap-2 px-4 min-w-0">
                  <img
                    src="/profile-circle-black.svg"
                    alt="User Avatar"
                    className="h-6 w-6 mb-2"
                  />
                  <h1 className="text-xl font-medium mb-2">
                    Open Account Information
                  </h1>
                </div>

                <div className="bg-white">
                  <div className="grid grid-cols-1 sm:grid-cols-2 xl:grid-cols-3 gap-4 sm:gap-6">
                    {/* Column 1 */}
                    <div className="flex flex-col px-4 pt-4">
                      <label className="mb-1 text-sm text-labelColour">
                        Full Name
                      </label>
                      <span className="break-words max-w-full">
                        {firstName}
                      </span>{' '}
                    </div>

                    {/* Column 2 */}
                    <div className="flex flex-col mx-4 lg:pt-4 pt-0 border-l-0 border-r-0 lg:border-l lg:border-r border-gray-300 px-4">
                      <label className="mb-1 text-sm text-labelColour">
                        Email
                      </label>
                      <span className="break-all whitespace-normal max-w-full">
                        {email}
                      </span>{' '}
                    </div>

                    {/* Column 3 */}
                    <div className="flex flex-col lg:pt-4 pt-0 px-4">
                      <label className="mb-1 text-sm text-labelColour">
                        Mobile Number
                      </label>
                      <span className="break-words max-w-full">
                        {mobileNumber}
                      </span>
                    </div>
                  </div>
                </div>
              </div>
              <div className="bg-white border rounded-md p-4 mt-4">
                <div className="flex justify-between items-start border-colour-custom px-4">
                  {/* Left Section: Icon + Heading */}
                  <div className="flex items-center space-x-2">
                    <img
                      src="/briefcase.svg"
                      alt="User Avatar"
                      className="h-6 w-6"
                    />
                    <h1 className="text-xl font-medium">
                      {roleName == 'business'
                        ? 'Business Information'
                        : 'Business Information'}
                    </h1>
                  </div>
                  <img
                    onClick={(e) => {
                      e.preventDefault();
                      handleEdit(stepStatus[0].id, 1);
                    }}
                    src="/edit-details.svg"
                    alt="Edit Icon"
                    className="w-4 h-4 cursor-pointer"
                  />
                </div>

                <div className="bg-white pb-4">
                  <div className="grid grid-cols-1 sm:grid-cols-2 xl:grid-cols-3 gap-4 sm:gap-6 border-b">
                    <div className="flex flex-col px-4 pt-4">
                      <label
                        htmlFor="firstName"
                        className="mb-1 text-sm text-labelColour"
                      >
                        Profile Picture
                      </label>
                      <div className="relative flex-shrink-0 mb-4 lg:mb-0 mt-1 mr-6">
                        <img
                          src={preview}
                          alt={`${fullName}`}
                          className="w-20 h-20 rounded-full object-cover"
                        />
                      </div>
                      <label
                        htmlFor="companyCategory"
                        className="mb-1 mt-4 text-sm text-labelColour"
                      >
                        {roleName == 'business'
                          ? 'Businesss Type'
                          : 'Business Type'}
                      </label>

                      <span>{accountTypeLabel}</span>

                      <label
                        htmlFor="fullName"
                        className="mb-1 mt-4 text-sm text-labelColour whitespace-normal words-break"
                      >
                        Full Name
                      </label>
                      <span>{fullName}</span>
                      <label
                        htmlFor="formerNames"
                        className="mb-1 mt-4 text-sm text-labelColour"
                      >
                        Trading Name
                      </label>
                      <span>{tradingName}</span>
                    </div>
                    <div className="flex flex-col lg:pt-4 pt-0  border-l-0 border-r-0 lg:border-l lg:border-r border-gray-300 px-4">
                      <label
                        htmlFor="applicantCountry"
                        className="mb-1 text-sm text-labelColour mt-4 whitespace-normal words-break"
                      >
                        Address of the Company's Registered Office
                      </label>

                      <span>{registeredAddress}</span>

                      <label
                        htmlFor="applicantCountry"
                        className="mb-1 text-sm text-labelColour mt-4 whitespace-normal words-break"
                      >
                        Postal Address
                      </label>

                      <span>{principalAddress}</span>
                    </div>
                    <div className="flex lg:pt-4 pt-0 flex-col pr-4">
                      <label
                        htmlFor="businessAddress"
                        className="mb-1 text-sm text-labelColour"
                      >
                        ABN
                      </label>
                      <span>{abn}</span>
                      <label
                        htmlFor="businessAddress"
                        className="mb-1 mt-4 text-sm text-labelColour"
                      >
                        ACN
                      </label>
                      <span>{acn}</span>
                      <label
                        htmlFor="applicantCountry"
                        className="mb-1 mt-4 text-sm text-labelColour"
                      >
                        Company Website
                      </label>
                      <span>{companyWebsite}</span>
                      <label
                        htmlFor="applicantCountry"
                        className="mb-1 mt-4 text-sm text-labelColour"
                      >
                        Industry
                      </label>
                      <span>{industry}</span>
                    </div>
                  </div>
                  <div className="flex flex-wrap items-center border-colour-custom gap-2 px-4 mt-4 min-w-0">
                    <h1 className="text-xl font-medium mb-2">
                      Contact Person Details
                    </h1>
                  </div>
                  <div className="grid grid-cols-1 sm:grid-cols-2 xl:grid-cols-3 gap-4 sm:gap-6">
                    <div className="flex flex-col px-4 pt-4">
                      <label
                        htmlFor="agentName"
                        className="mb-1 text-sm text-labelColour"
                      >
                        Full Name
                      </label>
                      <span>{agentName}</span>
                    </div>
                    <div className="flex flex-col lg:pt-4 pt-0  border-l-0 border-r-0 lg:border-l lg:border-r border-gray-300 px-4">
                      <label
                        htmlFor="applicantCountry"
                        className="mb-1 text-sm text-labelColour"
                      >
                        Email
                      </label>

                      <span>{emailContact}</span>
                    </div>
                    <div className="flex lg:pt-4 pt-0 flex-col pr-4">
                      <label
                        htmlFor="applicantCountry"
                        className="mb-1 text-sm text-labelColour"
                      >
                        Mobile Number
                      </label>

                      <span>{agentMobileNumber}</span>
                    </div>
                  </div>
                </div>
              </div>
              <div className="bg-white border rounded-md p-4 mt-4">
                <div className="flex justify-between items-start border-colour-custom px-4">
                  {/* Left Section: Icon + Heading */}
                  <div className="flex items-center space-x-2">
                    <img
                      src="/briefcase.svg"
                      alt="User Avatar"
                      className="h-6 w-6"
                    />
                    <h1 className="text-xl font-medium">Upload proof docs</h1>
                  </div>
                  <img
                    onClick={(e) => {
                      e.preventDefault();
                      handleEdit(stepStatus[1].id, 2);
                    }}
                    src="/edit-details.svg"
                    alt="Edit Icon"
                    className="w-4 h-4 cursor-pointer"
                  />
                </div>
                <div className="grid grid-cols-1 sm:grid-cols-2 xl:grid-cols-3 gap-4 sm:gap-6 pb-2">
                  {/* first column */}
                  <div className="flex flex-col px-4 pt-4 border-r-0 lg:border-r border-gray-300">
                    <div className="">
                      <FilePreview
                        label="Operating License Document"
                        file={fileOperatingLicenseDocument}
                        onClick={handleFileClick}
                      />
                    </div>
                    <div className="mt-4">
                      <label className="block mb-1 w-full text-sm text-[#464646]">
                        Expiry Date
                      </label>
                      <input
                        type="date"
                        value={expiryDate}
                        disabled={true}
                        className="block w-full p-2 text-black font-medium border border-gray-300 rounded-md text-md"
                      />{' '}
                    </div>
                  </div>
                  {/* second column */}
                  <div className="flex flex-col pr-4 pt-4 border-r-0 lg:border-r border-gray-300">
                    <div className="">
                      <FilePreview
                        label="Valid Registration Certificate"
                        file={fileCompanyRegistration}
                        onClick={handleFileClick}
                      />
                    </div>
                    {fileExtractDocument && (
                      <div className="mt-4">
                        <FilePreview
                          label="A search/extract of the relevant ASIC database"
                          file={fileExtractDocument}
                          onClick={handleFileClick}
                        />
                      </div>
                    )}
                  </div>
                  {/* third column */}
                  <div className="flex flex-col pr-4 pt-4">
                    {fileIncorporationCertificate && (
                      <div className="">
                        <FilePreview
                          label="Certificate of incorporation"
                          file={fileIncorporationCertificate}
                          onClick={handleFileClick}
                        />
                      </div>
                    )}
                  </div>
                </div>{' '}
              </div>
              <div
                className="
  bg-white
  rounded-3xl
  border
  border-slate-200
  shadow-sm
  mt-6
  overflow-hidden
  transition-all
  "
              >
                {/* HEADER */}
                <div
                  className="
    flex
    flex-col
    sm:flex-row
    sm:items-center
    justify-between
    gap-4
    p-5
    cursor-pointer
    hover:bg-slate-50
    transition
    "
                  onClick={() => setPaymentExpanded(!paymentExpanded)}
                >
                  <div className="flex items-center gap-4">
                    <div
                      className="
        h-12
        w-12
        rounded-2xl
        bg-[#375AE7]/10
        flex
        items-center
        justify-center
        "
                    >
                      <CreditCard size={22} className="text-[#375AE7]" />
                    </div>

                    <div>
                      <div className="flex items-center gap-2">
                        <h2
                          className="
            text-base
            sm:text-lg
            font-semibold
            text-slate-900
            "
                        >
                          Payment Method
                        </h2>

                        {cards?.length > 0 ? (
                          <span
                            className="
              px-2.5
              py-1
              rounded-full
              bg-emerald-100
              text-emerald-700
              text-xs
              font-semibold
              "
                          >
                            {cards.length} Added
                          </span>
                        ) : (
                          <span
                            className="
              px-2.5
              py-1
              rounded-full
              bg-amber-100
              text-amber-700
              text-xs
              font-semibold
              "
                          >
                            Required
                          </span>
                        )}
                      </div>

                      <p
                        className="
          text-sm
          text-slate-500
          mt-1
          flex
          items-center
          gap-1
        "
                      >
                        <ShieldCheck size={14} />
                        Secure & encrypted payment setup
                      </p>
                    </div>
                  </div>

                  <div
                    className="
      flex
      items-center
      gap-3
      "
                  >
                    <button
                      onClick={(e) => {
                        e.stopPropagation();
                        openCardCapture();
                      }}
                      className="
        flex
        items-center
        gap-2
        px-4
        py-2.5
        rounded-xl
        bg-[#375AE7]
        text-white
        text-sm
        font-semibold
        shadow-sm
        hover:bg-[#2f4fd1]
        transition
        "
                    >
                      <CreditCard size={16} />
                      Add Card
                    </button>

                    <ChevronDown
                      size={20}
                      className={`
        text-slate-400
        transition-transform
        ${paymentExpanded ? 'rotate-180' : ''}
        `}
                    />
                  </div>
                </div>

                {/* EXPANDED CONTENT */}

                {paymentExpanded && (
                  <div
                    className="
    border-t
    border-slate-100
    p-5
    space-y-6
    animate-in
    fade-in
    duration-200
    "
                  >
                    {/* DISCLOSURE */}

                    <div
                      className="
      bg-amber-50
      border
      border-amber-200
      rounded-2xl
      p-5
      "
                    >
                      <div
                        className="
        flex
        gap-3
        "
                      >
                        <div
                          className="
          h-9
          w-9
          rounded-xl
          bg-amber-100
          flex
          items-center
          justify-center
          "
                        >
                          <Lock size={18} className="text-amber-600" />
                        </div>

                        <div>
                          <h3
                            className="
            text-sm
            font-semibold
            text-amber-800
            "
                          >
                            Payment Timing Information
                          </h3>

                          <p
                            className="
            text-sm
            text-slate-700
            mt-2
            leading-relaxed
            "
                          >
                            Adding your card today does not trigger any payment.
                            Charges will only occur when your subscription
                            period begins, unless otherwise agreed.
                          </p>

                          <p
                            className="
            text-sm
            text-slate-700
            mt-2
            leading-relaxed
            "
                          >
                            You authorise Ratified Pty Limited to securely
                            charge your nominated card when subscription fees
                            become payable.
                          </p>
                        </div>
                      </div>
                    </div>

                    {/* NO CARDS STATE */}

                    {cards?.length === 0 ? (
                      <div
                        className="
        rounded-2xl
        border
        border-dashed
        border-slate-300
        bg-slate-50
        p-8
        text-center
        "
                      >
                        <div
                          className="
          mx-auto
          h-14
          w-14
          rounded-full
          bg-blue-100
          flex
          items-center
          justify-center
          "
                        >
                          <CreditCard size={26} className="text-[#375AE7]" />
                        </div>

                        <h3
                          className="
          mt-4
          font-semibold
          text-slate-900
          "
                        >
                          No payment method added
                        </h3>

                        <p
                          className="
          text-sm
          text-slate-500
          mt-2
          max-w-sm
          mx-auto
          "
                        >
                          Add a secure payment method to complete your
                          subscription setup.
                        </p>

                        <button
                          onClick={openCardCapture}
                          className="
          mt-5
          px-5
          py-2.5
          rounded-xl
          bg-[#375AE7]
          text-white
          text-sm
          font-semibold
          "
                        >
                          Add Payment Method
                        </button>
                      </div>
                    ) : (
                      <>
                        {/* YOUR EXISTING CARD SLIDER HERE */}

                        <div className="relative mt-6 overflow-hidden px-1 pb-2">
                          {' '}
                          <div
                            className="flex transition-transform duration-500 ease-out"
                            style={{
                              transform: `translateX(-${page * 100}%)`,
                            }}
                          >
                            {Array.from({ length: totalPages }).map(
                              (_, pageIndex) => {
                                const start = pageIndex * cardsPerPage;

                                const pageCards = cards.slice(
                                  start,
                                  start + cardsPerPage,
                                );

                                return (
                                  <div
                                    key={pageIndex}
                                    className="
          w-full
          grid
          grid-cols-1
          sm:grid-cols-2
          lg:grid-cols-3
          gap-5
          px-1
          shrink-0
          "
                                  >
                                    {pageCards.map((card) => {
                                      const brandUI = getCardBrandUI(
                                        card.card_brand?.toLowerCase(),
                                      );

                                      return (
                                        <div
                                          key={card.id}
                                          className={`
                relative
                rounded-3xl
                border
                transition-all
                duration-300
                ${'border-slate-200 bg-white'}
                `}
                                        >
                                          {/* CARD BODY */}

                                          <div
                                            onClick={() =>
                                              setSelectedCard(card)
                                            }
                                            className="
                  relative
                  h-[210px]
                  p-5
                  rounded-3xl
                  cursor-pointer
                  overflow-hidden
                  bg-gradient-to-br
                  from-white
                  via-slate-50
                  to-blue-50
                  "
                                          >
                                            {/* Soft ice highlight */}

                                            <div
                                              className="
                    absolute
                    -right-16
                    -top-16
                    w-40
                    h-40
                    rounded-full
                    bg-blue-200/30
                    blur-3xl
                    "
                                            />

                                            {/* HEADER */}

                                            <div
                                              className="
                    relative
                    flex
                    justify-between
                    items-start
                    "
                                            >
                                              <div>
                                                <p
                                                  className="
                        text-[11px]
                        tracking-widest
                        uppercase
                        text-slate-400
                        font-semibold
                        "
                                                >
                                                  {card.card_brand}
                                                </p>
                                              </div>

                                              <div className="flex items-center gap-2">
                                                {card.is_default && (
                                                  <div
                                                    className="
                          flex
                          items-center
                          gap-1
                          px-2
                          py-1
                          rounded-full
                          bg-emerald-100
                          text-emerald-700
                          text-[11px]
                          font-semibold
                          "
                                                  >
                                                    <CheckCircle size={12} />
                                                    Default
                                                  </div>
                                                )}

                                                {brandUI.logo && (
                                                  <img
                                                    src={brandUI.logo}
                                                    className="
                          h-8
                          object-contain
                          "
                                                    alt=""
                                                  />
                                                )}
                                              </div>
                                            </div>

                                            {/* CHIP */}

                                            <div
                                              className="
                    mt-7
                    h-9
                    w-14
                    rounded-lg
                    bg-gradient-to-br
                    from-yellow-200
                    to-yellow-400
                    "
                                            />

                                            {/* NUMBER */}

                                            <p
                                              className="
                    mt-5
                    text-xl
                    tracking-[0.22em]
                    font-semibold
                    text-slate-800
                    "
                                            >
                                              •••• •••• •••• {card.card_last4}
                                            </p>

                                            {/* FOOTER */}

                                            <div
                                              className="
                    absolute
                    bottom-5
                    left-5
                    right-5
                    flex
                    justify-between
                    "
                                            >
                                              <div>
                                                <p className="text-[11px] text-slate-400">
                                                  Expires
                                                </p>

                                                <p
                                                  className="
                      text-sm
                      font-semibold
                      text-slate-700
                      "
                                                >
                                                  {String(
                                                    card.card_expiry_month,
                                                  ).padStart(2, '0')}
                                                  /
                                                  {String(
                                                    card.card_expiry_year,
                                                  ).slice(-2)}
                                                </p>
                                              </div>
                                            </div>
                                          </div>

                                          {/* ACTIONS */}

                                          <div
                                            className="
                  p-4
                  flex
                  gap-3
                  border-slate-100
                  "
                                          >
                                            {!card.is_default && (
                                              <button
                                                onClick={() => {
                                                  setLoading(true);
                                                  handleSetDefault(card.id);
                                                }}
                                                className="
                      flex-1
                      h-10
                      rounded-xl
                      bg-[#375AE7]
                      text-white
                      text-sm
                      font-semibold
                      hover:bg-[#2f4fd1]
                      transition
                      "
                                              >
                                                Make Default
                                              </button>
                                            )}

                                            <button
                                              onClick={() => {
                                                setLoading(true);
                                                handleRemoveCard(card.id);
                                              }}
                                              className="
                    flex-1
                    h-10
                    rounded-xl
                    border
                    border-red-200
                    bg-red-50
                    text-red-600
                    text-sm
                    font-semibold
                    hover:bg-red-100
                    transition
                    "
                                            >
                                              Remove
                                            </button>
                                          </div>
                                        </div>
                                      );
                                    })}
                                  </div>
                                );
                              },
                            )}
                          </div>
                        </div>
                        {totalPages > 1 && (
                          <div className="flex justify-center gap-3 mt-5">
                            <button
                              onClick={prev}
                              disabled={page === 0}
                              className="px-3 py-2 rounded-full border bg-white shadow-sm disabled:opacity-30"
                            >
                              <ChevronLeft size={18} />
                            </button>

                            <div className="flex items-center gap-2">
                              {Array.from({ length: totalPages }).map(
                                (_, i) => (
                                  <div
                                    key={i}
                                    className={`w-2.5 h-2.5 rounded-full transition-all ${
                                      i === page
                                        ? 'bg-[#375AE7] scale-125'
                                        : 'bg-gray-300'
                                    }`}
                                  />
                                ),
                              )}
                            </div>

                            <button
                              onClick={next}
                              disabled={page === totalPages - 1}
                              className="px-3 py-2 rounded-full border bg-white shadow-sm disabled:opacity-30"
                            >
                              <ChevronRight size={18} />
                            </button>
                          </div>
                        )}

                        {/* SECURITY */}

                        <div
                          className="
        p-4
        rounded-2xl
        border
        bg-emerald-50
        flex
        gap-3
        "
                        >
                          <ShieldCheck
                            size={20}
                            className="text-emerald-600 mt-1"
                          />

                          <div>
                            <p
                              className="
          font-semibold
          text-emerald-900
          text-sm
          "
                            >
                              Your cards are secure
                            </p>

                            <p
                              className="
          text-sm
          text-emerald-800
          mt-1
          "
                            >
                              Payments are securely processed via NAB. Your card
                              details are encrypted and never stored.
                            </p>
                          </div>
                        </div>
                      </>
                    )}
                  </div>
                )}
              </div>

              {isAllCompleted && (
                <div className="bg-white border rounded-md p-4 mt-4">
                  <div className="flex justify-between items-start border-colour-custom px-4">
                    {/* Left Section: Icon + Heading */}
                    <div className="flex items-center space-x-2">
                      <span
                        className={`material-symbols-outlined ml-2 text-xl transition-all duration-300`}
                      >
                        description
                      </span>
                      <h1 className="text-xl font-medium">Agreements</h1>
                    </div>
                  </div>

                  <div className="mx-4">
                    <div className="grid grid-cols-1 sm:grid-cols-2 xl:grid-cols-3 gap-4 sm:gap-6">
                      {agreements.map(mapAgreementUI).map((agreement) => (
                        <AgreementCard
                          key={agreement.enum}
                          agreement={agreement}
                          agreed={agreedMap[agreement.enum]}
                          isLocked={lockedAgreements[agreement.enum]}
                          onPreview={(e) =>
                            handleFileClick(e, agreement.preview)
                          }
                          setAgreed={(checked) =>
                            handleAcceptAgreement(checked, agreement)
                          }
                        />
                      ))}
                    </div>
                  </div>
                </div>
              )}
            </>
          )}
        </div>
      </div>
      {stepStatus[2] &&
        stepStatus[2].status !== 'COMPLETED' &&
        stepStatus[2].status !== 'APPROVED' &&
        stepStatus[2].status !== 'IN_REVIEW' && (
          <footer className="bottom-actions flex flex-col flex-shrink-0 md:flex-row gap-3 md:gap-4 p-3 sm:p-4 pb-[calc(0.75rem+env(safe-area-inset-bottom))] sm:pb-4 bg-[#375AE7] sticky bottom-0 z-20 md:static w-full">
            <div className="flex flex-col sm:flex-row items-stretch sm:items-center justify-end w-full gap-2 sm:gap-3 md:gap-4 relative">
              {/* Save as Draft */}
              <button
                onClick={() => {
                  setIsConfirmWithdraw(true);
                }}
                className="flex w-full sm:w-auto min-h-[44px] items-center justify-center space-x-2 border-2 border-white text-white font-medium py-2 px-4 rounded-full text-sm"
              >
                <span>Withdraw Application</span>
              </button>

              <button
                onClick={(e) => {
                  e.preventDefault();
                  if (isAllCompleted) {
                    setLoading(true);
                    handleSubmit();
                  } else {
                    setIsConfirmSubmit(true);
                  }
                }}
                className="flex bg-white w-full sm:w-auto min-h-[44px] items-center justify-center space-x-2 border-2 border-white text-black font-medium py-2 px-4 rounded-full text-sm"
              >
                <span>Submit</span>
              </button>
            </div>
          </footer>
        )}
      {isModalOpen && currentDocument && (
        <DocumentPreview
          fileUrl={currentDocument.presigned_url}
          fileName={currentDocument?.file_name || currentDocument?.name}
          onClose={() => setIsModalOpen(false)}
        />
      )}
      {isConfirmWithdraw && (
        <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-50 p-4 overflow-y-auto">
          <div className="bg-white rounded-lg shadow-md w-full max-w-md p-5 sm:p-6 text-center">
            <button className="absolute top-3 right-3 text-black text-xl font-bold">
              &times;
            </button>

            <div className="flex justify-center items-center mb-4">
              <div className="flex items-center justify-center">
                <img
                  src="/warning-circle.svg"
                  alt="Add Template Icon"
                  className="h-10 w-10"
                />
              </div>
            </div>

            <h2 className="text-lg font-medium mb-2">
              Are you sure you want to Withdraw Application?
            </h2>
            <p className="text-sm text-black mb-4">
              This will delete all details entered during registration. None of
              the details entered in this form will be saved.
            </p>

            <div className="flex flex-col sm:flex-row justify-center gap-3 sm:gap-4">
              <button
                onClick={() => {
                  setIsConfirmWithdraw(false);
                }}
                className="px-6 py-2 border rounded-full text-black border-black font-medium hover:bg-gray-100"
              >
                No
              </button>
              <button
                onClick={(e) => {
                  e.preventDefault();
                  setLoading(true);
                  handleWithdraw();
                }}
                className="px-6 py-2 bg-[#375AE7] text-white rounded-full font-medium hover:bg-gray-800"
              >
                Yes
              </button>
            </div>
          </div>
        </div>
      )}
      {isConfirmSubmit && (
        <div className="fixed inset-0 z-10 flex items-center justify-center bg-black/60 backdrop-blur-sm px-4">
          <div className="w-full max-w-4xl max-h-[calc(100dvh-2rem)] sm:max-h-[90vh] bg-white rounded-2xl shadow-2xl flex flex-col overflow-hidden">
            {/* HEADER */}
            <div className="flex items-center justify-between px-4 sm:px-6 py-3 sm:py-4 border-b bg-gradient-to-r from-[#375AE7]/10 to-white">
              <div className="flex items-center gap-3">
                <div className="p-2 rounded-xl bg-[#375AE7]/10 text-[#375AE7]">
                  <span className="material-symbols-outlined text-xl">
                    description
                  </span>
                </div>

                <h1 className="text-lg md:text-xl font-semibold text-slate-800">
                  Agreements
                </h1>
              </div>

              <button
                onClick={() => setIsConfirmSubmit(false)}
                className="text-slate-500 hover:text-red-500 transition"
              >
                <span className="material-symbols-outlined">close</span>
              </button>
            </div>

            {/* BODY */}
            <div className="flex-1 overflow-y-auto overscroll-contain px-3 sm:px-6 py-4 sm:py-5 bg-slate-50">
              <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-2 gap-5">
                {agreements.map(mapAgreementUI).map((agreement) => (
                  <div
                    key={agreement.enum}
                    className="bg-white rounded-xl shadow-sm border hover:shadow-md transition p-3"
                  >
                    <AgreementCard
                      agreement={agreement}
                      agreed={agreedMap[agreement.enum]}
                      isLocked={lockedAgreements[agreement.enum]}
                      onPreview={(e) => handleFileClick(e, agreement.preview)}
                      setAgreed={(checked) =>
                        handleAcceptAgreement(checked, agreement)
                      }
                    />
                  </div>
                ))}
              </div>
            </div>

            {/* FOOTER */}
            <div className="flex justify-between items-center px-6 py-4 border-t bg-white">
              {/* LEFT: Privacy Policy */}
              <p className="text-xs md:text-sm text-gray-600 text-center md:text-left">
                Please see our{' '}
                <span
                  onClick={(e) => {
                    e.preventDefault();
                    navigate('/privacy-policy');
                  }}
                  className="text-blue-600 font-medium hover:underline cursor-pointer"
                >
                  Privacy Policy
                </span>{' '}
                for information about how we process your data.
              </p>

              {/* RIGHT: Actions */}
              <div className="flex gap-3">
                <button
                  onClick={() => setIsConfirmSubmit(false)}
                  className="px-5 py-2 rounded-xl border border-slate-300 text-slate-700 hover:bg-slate-100 transition"
                >
                  Cancel
                </button>

                <button
                  onClick={(e) => {
                    e.preventDefault();

                    const { isValid, missing } = validateAgreementsBeforeNext();

                    if (!isValid) {
                      showToast(
                        'Please accept all required agreements. Missing: ' +
                          missing.map((a) => a.name).join(', '),
                        'error',
                      );
                      return;
                    }

                    setLoading(true);
                    handleSubmit();
                  }}
                  className="px-5 py-2 rounded-xl bg-[#375AE7] text-white font-medium hover:bg-[#2f4bd3] transition shadow-sm"
                >
                  Submit
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
      {showCardModal && (
        <div
          className="
fixed inset-0
bg-slate-900/60
backdrop-blur-md
flex
items-center
justify-center
z-50
px-4
"
        >
          <div
            className="
w-full
max-w-xl
max-h-[90vh]
bg-white
rounded-3xl
shadow-2xl
overflow-hidden
flex
flex-col
"
          >
            {/* HEADER */}

            <div
              className="
bg-gradient-to-r
from-[#375AE7]
to-indigo-600
p-6
text-white
"
            >
              <div className="flex justify-between items-start">
                <div className="flex gap-4 items-center">
                  <div
                    className="
h-14
w-14
rounded-2xl
bg-white/20
flex
items-center
justify-center
"
                  >
                    <CreditCard size={28} />
                  </div>

                  <div>
                    <h2 className="text-xl font-bold">Add Payment Card</h2>

                    <p className="text-sm text-blue-100 mt-1">
                      Secure payment powered by NAB
                    </p>
                  </div>
                </div>

                <button
                  onClick={() => {
                    setShowCardModal(false);
                    clearCardForm();
                  }}
                  className="
h-9
w-9
rounded-full
bg-white/20
hover:bg-white/30
flex
items-center
justify-center
transition
"
                >
                  ✕
                </button>
              </div>
            </div>

            {/* BODY */}

            <div
              className="
p-6
space-y-5
overflow-y-auto
flex-1
custom-scrollbar
"
            >
              {/* SECURITY + CARD INFO */}

              <div className="space-y-5">
                {/* Secure Banner */}

                <div
                  className="
relative
overflow-hidden
flex
items-start
gap-4
bg-gradient-to-br
from-emerald-50
via-teal-50
to-cyan-50
border
border-emerald-200
rounded-3xl
p-5
shadow-sm
"
                >
                  <div
                    className="
absolute
right-0
top-0
h-20
w-20
bg-emerald-200/30
rounded-full
blur-2xl
"
                  />

                  <div
                    className="
relative
h-12
w-12
rounded-2xl
bg-white
shadow-md
flex
items-center
justify-center
shrink-0
"
                  >
                    <LockKeyhole size={24} className="text-emerald-600" />
                  </div>

                  <div className="relative">
                    <p
                      className="
font-semibold
text-emerald-900
text-sm
"
                    >
                      Secure payment encryption enabled
                    </p>

                    <p
                      className="
text-xs
text-emerald-700
mt-1
leading-relaxed
"
                    >
                      Your card details are securely processed through NAB and
                      are never stored on our systems.
                    </p>
                  </div>
                </div>

                {/* Supported Cards */}

                <div
                  className="
rounded-3xl
border
border-slate-200
bg-white
p-5
shadow-sm
"
                >
                  <div
                    className="
flex
items-center
gap-3
mb-4
"
                  >
                    <div
                      className="
h-10
w-10
rounded-xl
bg-blue-50
flex
items-center
justify-center
"
                    >
                      <Info size={19} className="text-[#375AE7]" />
                    </div>

                    <div>
                      <h3
                        className="
text-sm
font-bold
text-slate-800
"
                      >
                        Supported payment cards
                      </h3>

                      <p
                        className="
text-xs
text-slate-500
"
                      >
                        Securely add one of the supported cards below
                      </p>
                    </div>
                  </div>

                  <p
                    className="
text-xs
text-slate-600
leading-relaxed
mb-5
"
                  >
                    We currently accept only Visa, Mastercard and American
                    Express cards. Other card types are not supported.
                  </p>

                  <div
                    className="
grid
grid-cols-3
gap-3
"
                  >
                    {['visa', 'mastercard', 'amex'].map((brand) => {
                      const card = getCardBrandUI(brand);

                      return (
                        <div
                          key={brand}
                          className="
group
relative
h-20
rounded-2xl
overflow-hidden
border
border-slate-200
bg-white
shadow-sm
hover:shadow-lg
transition-all
duration-300
hover:-translate-y-1
"
                        >
                          {/* Gradient Top */}

                          <div
                            className={`
absolute
inset-x-0
top-0
h-1
bg-gradient-to-r
${card.gradient}
`}
                          />

                          <div
                            className="
h-full
flex
flex-col
items-center
justify-center
gap-2
"
                          >
                            {card.logo && (
                              <img
                                src={card.logo}
                                alt={`${brand} card`}
                                className="
h-8
w-auto
object-contain
transition
group-hover:scale-110
"
                              />
                            )}

                            <span
                              className="
text-[10px]
uppercase
tracking-wide
font-semibold
text-slate-400
"
                            >
                              Accepted
                            </span>
                          </div>
                        </div>
                      );
                    })}
                  </div>
                </div>
              </div>

              <div
                className="
grid
grid-cols-1
md:grid-cols-2
gap-5
"
              >
                {/* MICROFORM CARD NUMBER */}

                <div className="md:col-span-2">
                  <label className="text-sm font-semibold text-slate-700 mb-2 block">
                    Card Number
                  </label>

                  <div
                    className={`
relative h-[54px] rounded-xl px-4 flex items-center transition-all
border
${
  cardError
    ? 'border-red-400 ring-1 ring-red-100'
    : cardFocused
      ? 'ring-2 ring-[#375AE7]'
      : 'border-slate-200'
}
bg-white shadow-sm
`}
                  >
                    <CreditCard size={18} className="text-slate-400 mr-2" />

                    <div
                      id="card-number-container"
                      className="flex-1 h-full flex items-center"
                    />
                    {cardSuccess && <SuccessTick />}
                  </div>

                  {cardError && (
                    <p className="text-xs text-red-500 mt-1 flex items-center gap-1">
                      ⚠ {cardError}
                    </p>
                  )}
                </div>

                {/* EXPIRY */}

                <div>
                  <label
                    className="
text-sm
font-semibold
text-slate-700
mb-2
block
"
                  >
                    Expiry
                  </label>

                  <div className="relative">
                    <Calendar
                      size={16}
                      className="absolute left-3 top-1/2 -translate-y-1/2 text-gray-400 mr-2"
                    />
                    <input
                      value={cardExpiry}

                      onChange={(e) =>
                        setCardExpiry(formatExpiry(e.target.value))
                      }

                      placeholder="MM/YY"

                      maxLength={5}

                      className="
w-full
rounded-xl
border
border-slate-200
pl-10
py-3
focus:ring-2
focus:ring-[#375AE7]
outline-none placeholder:text-[#b6c2d1]

"
                    />
                    {!expiryError && cardExpiry.length === 5 && (
                      <div className="absolute right-3 top-3">
                        <SuccessTick />
                      </div>
                    )}
                  </div>
                  {expiryError && (
                    <p className="text-xs text-red-500 mt-1 flex items-center gap-1">
                      ⚠ {expiryError}
                    </p>
                  )}
                </div>

                {/* CVV MICROFORM */}

                <div>
                  <label className="text-sm font-semibold text-slate-700 mb-2 flex items-center gap-2">
                    CVV
                    <span className="text-xs text-slate-400">(3–4 digits)</span>
                  </label>

                  <div
                    className={`focus:ring-2
focus:ring-[#375AE7] 
relative h-[54px] rounded-xl px-3 flex items-center transition-all
border 
${
  cvvError
    ? 'border-red-400 ring-1 ring-red-100'
    : cvvFocused
      ? 'ring-2 ring-[#375AE7]'
      : 'border-slate-200'
}
bg-white shadow-sm
`}
                  >
                    <ShieldCheck size={18} className="text-slate-400 mr-2" />

                    <div
                      id="card-cvv-container"
                      className="flex-1 h-full flex items-center"
                    />
                    {cvvSuccess && <SuccessTick />}
                  </div>

                  {cvvError && (
                    <p className="text-xs text-red-500 mt-1 flex items-center gap-1">
                      ⚠ {cvvError}
                    </p>
                  )}
                </div>
              </div>
              <div
                className="
flex
items-center
justify-between
rounded-2xl
border
border-blue-100
bg-blue-50
p-4
"
              >
                <div>
                  <p className="text-sm font-semibold text-slate-800">
                    Default payment method
                  </p>

                  <p className="text-xs text-slate-500 mt-1">
                    Use this card automatically for future payments
                  </p>
                </div>

                <label className="relative inline-flex items-center cursor-pointer">
                  <input
                    type="checkbox"
                    checked={isDefaultCard}
                    onChange={() => setIsDefaultCard(!isDefaultCard)}
                    className="sr-only peer"
                  />

                  <div
                    className="
w-11
h-6
bg-slate-300
rounded-full
peer
peer-checked:bg-[#375AE7]
transition
after:absolute
after:top-[2px]
after:left-[2px]
after:h-5
after:w-5
after:bg-white
after:rounded-full
after:transition
peer-checked:after:translate-x-full
"
                  />
                </label>
              </div>
              <div
                className="
rounded-2xl
border
border-slate-200
bg-slate-50
p-4
"
              >
                <div className="flex items-center justify-between">
                  <div>
                    <h3 className="text-sm font-semibold text-slate-800">
                      Billing Address
                    </h3>

                    <p className="text-xs text-slate-500 mt-1">
                      Use a different billing address for this card
                    </p>
                  </div>

                  <label className="relative inline-flex items-center cursor-pointer">
                    <input
                      type="checkbox"
                      checked={isBillingDifferent}
                      onChange={() =>
                        setIsBillingDifferent(!isBillingDifferent)
                      }
                      className="sr-only peer"
                    />

                    <div
                      className="
w-11
h-6
bg-slate-300
rounded-full
peer
peer-checked:bg-[#375AE7]
transition
after:absolute
after:top-[2px]
after:left-[2px]
after:bg-white
after:h-5
after:w-5
after:rounded-full
after:transition-all
peer-checked:after:translate-x-full
"
                    />
                  </label>
                </div>
              </div>
              <div
                className={`
transition-all duration-300 overflow-hidden
${isBillingDifferent ? 'max-h-[500px] opacity-100 mt-4' : 'max-h-0 opacity-0'}
`}
              >
                <div
                  className="
grid
grid-cols-1
md:grid-cols-2
gap-4
border
border-slate-200
rounded-2xl
p-4
bg-white
"
                >
                  <div className="col-span-2">
                    <label className="text-sm font-medium text-gray-600 mb-1 block">
                      Address
                    </label>
                    <input
                      type="text"
                      value={billingAddress.address}
                      onChange={(e) =>
                        setBillingAddress({
                          ...billingAddress,
                          address: e.target.value,
                        })
                      }
                      placeholder="Street address"
                      className="w-full border border-gray-200 rounded-xl px-4 py-2.5 focus:outline-none focus:ring-2 focus:ring-[#375AE7]"
                    />
                    {billingErrors.address && (
                      <p className="text-xs text-red-500 mt-1">
                        ⚠ {billingErrors.address}
                      </p>
                    )}
                  </div>

                  <div>
                    <label className="text-sm font-medium text-gray-600 mb-1 block">
                      City
                    </label>
                    <input
                      type="text"
                      value={billingAddress.city}
                      onChange={(e) =>
                        setBillingAddress({
                          ...billingAddress,
                          city: e.target.value,
                        })
                      }
                      placeholder="City"
                      className="w-full border border-gray-200 rounded-xl px-4 py-2.5 focus:outline-none focus:ring-2 focus:ring-[#375AE7]"
                    />
                    {billingErrors.city && (
                      <p className="text-xs text-red-500 mt-1">
                        ⚠ {billingErrors.city}
                      </p>
                    )}
                  </div>

                  <div>
                    <label className="text-sm font-medium text-gray-600 mb-1 block">
                      State
                    </label>
                    <input
                      type="text"
                      value={billingAddress.state}
                      onChange={(e) =>
                        setBillingAddress({
                          ...billingAddress,
                          state: e.target.value,
                        })
                      }
                      placeholder="State"
                      className="w-full border border-gray-200 rounded-xl px-4 py-2.5 focus:outline-none focus:ring-2 focus:ring-[#375AE7]"
                    />
                    {billingErrors.state && (
                      <p className="text-xs text-red-500 mt-1">
                        ⚠ {billingErrors.state}
                      </p>
                    )}
                  </div>
                  <div>
                    <label className="text-sm font-medium text-gray-600 mb-1 block">
                      ZIP Code
                    </label>
                    <input
                      type="text"
                      value={billingAddress.zip}
                      onChange={(e) =>
                        setBillingAddress({
                          ...billingAddress,
                          zip: e.target.value,
                        })
                      }
                      placeholder="ZIP Code"
                      className="w-full border border-gray-200 rounded-xl px-4 py-2.5 focus:outline-none focus:ring-2 focus:ring-[#375AE7]"
                    />
                    {billingErrors.zip && (
                      <p className="text-xs text-red-500 mt-1">
                        ⚠ {billingErrors.zip}
                      </p>
                    )}
                  </div>
                  <div>
                    <label className="text-sm font-medium text-gray-600 mb-1 block">
                      Country
                    </label>
                    <input
                      type="text"
                      value={billingAddress.country}
                      onChange={(e) =>
                        setBillingAddress({
                          ...billingAddress,
                          country: e.target.value,
                        })
                      }
                      placeholder="Country"
                      className="w-full c border border-gray-200 rounded-xl px-4 py-2.5 focus:outline-none focus:ring-2 focus:ring-[#375AE7]"
                    />
                    {billingErrors.country && (
                      <p className="text-xs text-red-500 mt-1">
                        ⚠ {billingErrors.country}
                      </p>
                    )}
                  </div>
                </div>
              </div>
            </div>

            {/* FOOTER */}

            <div
              className="
border-t
border-slate-200
p-5
flex
flex-col
sm:flex-row
gap-3
justify-end
bg-white
sticky
bottom-0
"
            >
              <button
                onClick={() => {
                  setShowCardModal(false);
                  clearCardForm();
                }}
                className="
h-12
px-6
rounded-xl
border
border-slate-200
bg-white
text-slate-700
font-semibold
hover:bg-slate-50
transition
"
              >
                Cancel
              </button>

              <button
                onClick={() => {
                  setSaveAttempted(true);

                  if (validateCardForm()) {
                    setLoading(true);
                    handleSaveCard();
                  }
                }}
                disabled={
                  !microformReady ||
                  savingCard ||
                  !cardSuccess ||
                  !cvvSuccess ||
                  !cardExpiry
                }
                className={`
h-12
px-8
rounded-xl
font-semibold
transition-all
flex
items-center
justify-center
gap-2
${
  !cardSuccess || !cvvSuccess || !cardExpiry || savingCard
    ? 'bg-slate-300 text-white cursor-not-allowed'
    : 'bg-gradient-to-r from-[#375AE7] to-indigo-600 text-white shadow-md hover:shadow-lg hover:scale-[1.02]'
}
`}
              >
                {savingCard ? 'Saving...' : 'Save Card'}
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default ReviewSubmitBusiness;
